// ** React Imports
import React, { useEffect, useState } from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import TabSwitcher from 'src/components/common/containers/TabSwitcher'
import { rewardsPageTabList } from 'src/assets/RewardsConfig'
import { SwitchableTabType } from 'src/lib/types/random'
import RewardsSetupTab from 'src/components/rewards/setup/SetupTab'
import RewardsAnalyticsTab from 'src/components/rewards/analytics/AnalyticsTab'
import RewardsCustomisationTab from 'src/components/rewards/customisation/RewardsCustomisationTab'
import { RewardsConfigProvider } from 'src/lib/contexts/RewardsConfigContext'
import { useRouter } from 'next/router'
import { useRewardsPermissions } from 'src/lib/access-permission-hooks/useRewardsPermissions'
import { useUser } from 'src/lib/contexts/UserContext'

const Rewards: React.FC<{}> = () => {
  const { t } = useLocale()
  const { user } = useUser()
  const [tabList, setTabList] = useState<SwitchableTabType[] | undefined>(rewardsPageTabList)

  const router = useRouter()
  const tabName = router?.asPath.split('#')
  const activeTab = tabList?.find((tab: SwitchableTabType) => tab?.isActive)?.name

  const { canViewRewardsSetup, canViewRewardsCustomisation, canViewRewardsAnalytics } = useRewardsPermissions()

  useEffect(() => {
    const shouldTabCanBeAccessed = () => {
      if (!canViewRewardsSetup) {
        setTabList(tabList?.filter((tab: SwitchableTabType) => tab?.name !== 'setup'))
      }
      if (!canViewRewardsCustomisation) {
        setTabList(tabList?.filter((tab: SwitchableTabType) => tab?.name !== 'customisation'))
      }
      if (!canViewRewardsAnalytics) {
        setTabList(tabList?.filter((tab: SwitchableTabType) => tab?.name !== 'analytics'))
      }
    }
    if (user) shouldTabCanBeAccessed()
  }, [canViewRewardsSetup, canViewRewardsCustomisation, canViewRewardsAnalytics])

  useEffect(() => {
    activateTab()
  }, [])

  const activateTab = () => {
    let index = 0
    if (tabList) {
      const modifiedTabList = [...tabList]
      for (let i = 0; i < modifiedTabList?.length; i++) {
        modifiedTabList[i].isActive = false
        if (modifiedTabList[i]?.name === tabName?.[1]) index = i
      }
      modifiedTabList[index].isActive = true
      setTabList([...modifiedTabList])
    }
  }
  const mapActiveTab = () => {
    switch (activeTab) {
      case 'setup':
        return <RewardsSetupTab />
      case 'customisation':
        return <RewardsCustomisationTab />
      case 'analytics':
        return <RewardsAnalyticsTab />
      default:
        return <></>
    }
  }

  return (
    <div
      className='p-8'
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 16
      }}
    >
      <h6 className='font-semibold text-carbon text-lg'>{t('rewards')}</h6>

      <RewardsConfigProvider>
        <TabSwitcher tabList={tabList} setTabList={setTabList} isFragmentationEnabled={true}>
          {mapActiveTab()}
        </TabSwitcher>
      </RewardsConfigProvider>
    </div>
  )
}

export default Rewards
